export const DRAWDOWNS_ITEMS_PER_PAGE = 10;
export const DRAWDOWNS_SORTING_KEY = 'closeDate';
export const CREDIT_POOL_MAX_NAME_CHARACTERS = 30;
export const DISTRIBUTION_DEALS_TABLE_INITIAL_PAGE = 1;
